// frontend/src/context/AuthContext.jsx
import React, { createContext, useState, useEffect, useCallback } from 'react';
import api from '../services/api';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(localStorage.getItem('userToken'));
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true); // CRITICAL: starts as true

  const login = useCallback((newToken) => {
    setToken(newToken);
  }, []);

  const logout = useCallback(() => {
    setToken(null);
    setUser(null);
  }, []);

  const fetchUserData = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await api.get('/auth/me');
      setUser(data.data);
    } catch (error) {
      logout();
    } finally {
      setLoading(false);
    }
  }, [logout]);

  useEffect(() => {
    if (token) {
      localStorage.setItem('userToken', token);
      api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      fetchUserData();
    } else {
      localStorage.removeItem('userToken');
      delete api.defaults.headers.common['Authorization'];
      setUser(null);
      setLoading(false); // CRITICAL: set false when no token
    }
  }, [token, fetchUserData]);

  const isClinica = user?.role === 'clinica';

  const value = {
    isAuthenticated: !!token,
    token,
    user,
    loading,
    login,
    logout,
    isAdmin: user?.role === 'admin',
    isFisioterapeuta: user?.role === 'fisioterapeuta',
    isPaciente: user?.role === 'paciente',
    isClinica,
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;